/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getLatestLocationVisited} from '../api'

 export const useQueryGetLatestLocationVisited = createReactQueryHook('getLatestLocationVisited', getLatestLocationVisited)
